import { createFileRoute } from "@tanstack/react-router";
import TmsForPoliceOfficers from "@/pages/TmsForPoliceOfficers";
export const Route = createFileRoute("/tms-for-police-officers")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Police Officers | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for police officers with depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "TMS For Police Officers | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for police officers with depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-police-officers",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-police-officers",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForPoliceOfficers />;
}
